import type { Address, DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  type AutocompleteParams,
  getAutocompleteFn,
} from './ahafood/get-autocomplete-fn';

export const useAutocomplete = (
  params: AutocompleteParams,
  opts?: Partial<UseQueryOptions<Address[], DefaultQueryError>>
) =>
  useQuery<Address[], DefaultQueryError>({
    queryKey: ['autocomplete', params],
    queryFn: () => getAutocompleteFn(params),
    // enabled: !!params.input,
    ...opts,
  });
